import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
type Layer = {
  name: string;
  tone: string;
  items: string[];
  focus?: string;
  focusNote?: string;
};
const layers: Layer[] = [{
  name: 'Professional applications',
  tone: '#F4F7FC',
  items: ['Venture Capital', 'Private Equity', 'Corporate Innovation', 'M&A', 'Procurement', 'Research', 'Technology Diligence'],
  focus: 'Venture Capital',
  focusNote: 'Initial wedge'
}, {
  name: 'Industry workflows',
  tone: INK.violet,
  items: ['Diligence', 'Research', 'Scoring', 'Investment memos', 'Technology assessments', 'Market mapping', 'Monitoring', 'Reporting']
}, {
  name: 'Institutional intelligence',
  tone: INK.emerald,
  items: ['Firm memory', 'Company history', 'Analyst feedback', 'Benchmarks', 'Historical decisions', 'Documents', 'Outcome data']
}, {
  name: 'AI orchestration',
  tone: INK.blue,
  items: ['Agentic workflows', 'Deterministic functions', 'Closed-loop scripts', 'Model routing', 'Validation', 'Scoring']
}, {
  name: 'Model layer',
  tone: INK.gold,
  items: ['Frontier LLMs', 'Specialized DiligenceGPT™ models', 'Classification', 'Extraction', 'Financial models'],
  focus: 'Frontier LLMs',
  focusNote: 'One component'
}, {
  name: 'Data infrastructure',
  tone: '#8B95A8',
  items: ['Private client', 'Partner', 'Paid', 'Public', 'Proprietary StartupFuel', 'Research']
}];
export function IntelligenceStackSlide() {
  return <Slide data-id="element-289" data-mp="j3dhoy2otj86">
      <div className="flex items-end justify-between gap-[4cqw]" data-id="element-290" data-mp="j3n8gnvk3uex">
        <div data-id="element-291" data-mp="n2w6w61jkggt">
          <Eyebrow data-id="element-292" data-mp="n4gypnwh1laz">Technology architecture</Eyebrow>
          <Title className="mt-[2.2cqh]" data-id="element-293" data-mp="93wd6jz69bds">The DiligenceGPT™ Intelligence Stack</Title>
        </div>
        <p className="max-w-[40%] text-right text-[1.25cqw] leading-snug text-[#C3CBD9]" style={SERIF} data-id="element-294" data-mp="e2zk69ypproe">
          Foundation models provide intelligence. DiligenceGPT™ provides the
          infrastructure required to operationalize it.
        </p>
      </div>

      <div className="mt-auto flex flex-col gap-[0.9cqh]" data-id="element-295" data-mp="2azvmbbkq9di5">
        {layers.map((layer, i) => {
        const isModel = layer.name === 'Model layer';
        return <Reveal key={layer.name} delay={0.05 * i} className={isModel ? 'grid grid-cols-[3cqw_16cqw_1fr] items-center border border-dashed border-[#D8A55A]/40 bg-transparent px-[1.4cqw] py-[1.9cqh]' : 'grid grid-cols-[3cqw_16cqw_1fr] items-center border border-white/10 bg-white/[0.022] px-[1.4cqw] py-[1.9cqh]'} data-id="element-296" data-mp="221tcc6j0naiq" data-mpi={i}>
              <span className="text-[0.76cqw] tracking-[0.22em] text-white/30" data-id="element-297" data-mp="2ktcbu3du06g0">
                {String(i + 1).padStart(2, '0')}
              </span>
              <div className="flex items-center gap-[0.8cqw]" data-id="element-298" data-mp="19bte2qj0svou">
                <span className="h-[2.6cqh] w-[2px]" style={{
              background: layer.tone
            }} data-id="element-299" data-mp="z85ziilqdbvs" />
                <span className="text-[0.84cqw] uppercase tracking-[0.18em]" style={{
              color: layer.tone
            }} data-id="element-300" data-mp="z6bcmyqwf9p2">
                  {layer.name}
                </span>
              </div>
              <div className="flex flex-wrap items-center gap-x-[1.5cqw] gap-y-[0.6cqh]" data-id="element-301" data-mp="1950vouuj706w">
                {layer.items.map(item => item === layer.focus ? <span key={item} className="flex items-baseline gap-[0.6cqw] border border-white/25 px-[0.8cqw] py-[0.5cqh]" data-id="element-302" data-mp="1hxug16ou4prm">
                      <span className="text-[1cqw] text-[#F4F7FC]" data-id="element-303" data-mp="1mztimecr3ini">{item}</span>
                      <span className="text-[0.64cqw] uppercase tracking-[0.18em]" style={{
                color: layer.tone === '#F4F7FC' ? INK.blue : layer.tone
              }} data-id="element-304" data-mp="1rxczzn4qwbjo">
                        {layer.focusNote}
                      </span>
                    </span> : <span key={item} className="text-[1cqw] text-[#C3CBD9]" data-id="element-305" data-mp="1syqtl3cff3er">
                      {item}
                    </span>)}
              </div>
            </Reveal>;
      })}
      </div>
    </Slide>;
}